import React from 'react';

import {
  InvitationQueue,
  useCriterionStateInfo,
  useParticipantFieldsByName,
} from '@app/api';
import { CriterionConfigTableLines } from './CriterionConfigTableLines';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

interface Props {
  queue?: InvitationQueue;
  selectedWhiteList?: string[];
}

const useStyles = createUseStyles((theme: Theme) => ({
  table: {
    ...theme.fonts.body,
    minWidth: theme.maxContentWidth.regular,
    '& th': {
      textAlign: 'left',
    },

    '& th, & td': {
      paddingRight: theme.marginBase * 3,
      paddingLeft: theme.marginBase,
    },

    '& tr:nth-child(even)': {
      backgroundColor: theme.colors.grayBackground,
    },
  },
}));

export const CriteriaConfigTable = ({ queue, selectedWhiteList }: Props) => {
  const classes = useStyles();
  const config = queue?.scoringConfiguration;

  const participantFieldsByName = useParticipantFieldsByName();

  const { data: criterionQuotaAndStateInfos } = useCriterionStateInfo(
    queue?.id,
  );

  return (
    <table className={classes.table}>
      <thead>
        <tr>
          <th />
          <th />
          <th>Manq.</th>
          <th>Pds Manq.</th>
          <th># panel</th>
          <th>Pds. panel</th>
          <th>Poids</th>
        </tr>
      </thead>
      <tbody>
        {criterionQuotaAndStateInfos?.map(
          (criterionStateInfo) =>
            !criterionStateInfo.screenerCriterion && (
              <CriterionConfigTableLines
                key={criterionStateInfo.fieldRef}
                criterionStateInfo={criterionStateInfo}
                field={participantFieldsByName?.[criterionStateInfo.fieldRef]}
                config={config?.criteriaConfig?.[criterionStateInfo.fieldRef]}
                fieldRef={criterionStateInfo.fieldRef}
                selectedWhiteList={selectedWhiteList}
              />
            ),
        )}
      </tbody>
    </table>
  );
};
